import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import { bind } from '../../utils/decorators';
import * as ApiTypeFactory from '../../models/ApiTypeFactory';
import * as ApiTypes from '../../models/ApiTypes';

/** Basisklasse für Komponenten zum Anlegen von neuen Aufträgen - Nicht direkt verwenden */
@observer
export default class AuftragAnlegen extends React.Component<{}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  // Kopfdaten
  @observable lizenznehmer: string = '';
  @observable verantwortlicher: string = '';
  @observable referenzdatum: string = '';
  @observable bemerkung = '';

  @observable auftraggeber: ApiTypes.IAdresse = ApiTypeFactory.leereAdresse();
  @observable untersuchungsort: ApiTypes.IAdresse = ApiTypeFactory.leereAdresse();
  @observable untersuchungsortGleichAuftraggeber: boolean = false;

  @observable auftragskopfGeladen: boolean = false;

  @bind @action setAuftragskopfGeladen(wert: boolean) {
    this.auftragskopfGeladen = wert;
  }

  /** Gemeinsam genutzte Eventhandller für Eingabefelder */
  @bind @action handleLizenznehmerChanged(event: React.FormEvent<FormControl>) {
    this.lizenznehmer = (event.target as HTMLInputElement).value;
  }

  @bind @action handlePiChanged(event: React.FormEvent<FormControl>) {
    this.verantwortlicher = (event.target as HTMLInputElement).value;
  }

  @bind @action handleDatumChanged(event: React.FormEvent<FormControl>) {
    this.referenzdatum = (event.target as HTMLInputElement).value;
  }

  @bind @action handleBemerkungChanged(event: React.FormEvent<FormControl>) {
    this.bemerkung = (event.target as HTMLInputElement).value;
  }

  @bind @action handleUntersuchungsortGleichAuftraggeberChange(event: React.FormEvent<FormControl>) {
    this.untersuchungsortGleichAuftraggeber = (event.target as HTMLInputElement).checked;
    if (!this.untersuchungsortGleichAuftraggeber) {
      this.untersuchungsort = ApiTypeFactory.leereAdresse();
    }
  }

  /** Gemeinsam genutzte Setter für Auftragseigenschaften */
  @bind @action setVerantwortlicher(verantwortlicher: string) {
    this.verantwortlicher = verantwortlicher;
  }

  @bind @action setLizenznehmer(lizenznehmer: string) {
    this.lizenznehmer = lizenznehmer;
  }

  @bind @action setAuftraggeber(adresse: ApiTypes.IAdresse) {
    this.auftraggeber = adresse;
  }

  @bind @action setUntersuchungsort(adresse: ApiTypes.IAdresse) {
    this.untersuchungsort = adresse;
  }

  /** Setzt das Referenzdatum für einen neuen Auftrag auf heute */
  @bind @action setReferenzDatum() {
    let datum = new Date();
    let datumISO = datum.getFullYear() + '-' + ('0' + (datum.getMonth() + 1)).slice(-2) + '-' + ('0' + datum.getDate()).slice(-2);
    this.referenzdatum = datumISO;
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragAnlegen.tsx